import { inject, Injectable } from "@angular/core"
import { FireStoreService } from "@services/fire-store.service"
import { REFERENTIAL, ReferentialDTO, ReferentialService } from "@pages/admin/referential/referential.service"
import { arrayUnion } from "@angular/fire/firestore"

export interface SubVersionDTO {
  id: string
  title: string
  title_internal: string
  content: string
  date: Date
  layout?: any
  backgroundImg?: string
  hideTitleSection: boolean
}

export interface SubSectionDTO {
  id?: string

  category?: { id: string }
  program?: { id: string }
  title_internal: string

  versions: Array<SubVersionDTO>

  versions_label?: string // generated
  category_label?: string // generated
  program_label?: string
}

@Injectable({
  providedIn: "root",
})
export class SubSectionService extends FireStoreService<SubSectionDTO> {
  refService = inject(ReferentialService)

  constructor() {
    super()
    this.init({
      collectionKey: `sub-section`,
      fullTextFields: ["title_internal", "versions_label", "category_label"],
    })
  }

  override toDTO(dto: SubSectionDTO, action: string): Promise<SubSectionDTO> {
    return Promise.all([
      this.refService.getAllFromCache(REFERENTIAL.category_subsection),
      this.refService.getAllFromCache(REFERENTIAL.program_code),
    ]).then((refs) => {
      const [refCategory, refProgram] = refs
      dto.category_label = refCategory.find((x: ReferentialDTO) => x.id === dto.category?.id)?.name || "-"
      dto.program_label = refProgram.find((x: ReferentialDTO) => x.id === dto.program?.id)?.name || "-"

      dto.versions_label =
        (dto.versions?.length > 0 ? `[${dto.versions?.length}] ` : "") +
        (dto.versions?.map((v) => v.title).join(", ") || "")

      if (dto.versions) {
        dto.versions.sort((a, b) => b.date.getTime() - a.date.getTime())
      }
      return dto
    })
  }
}
